import React from 'react';

// Единый вид сущности в списках админки: название, под ним владелец, под ним
// ID. До этого в каждом разделе показывали что-то своё — где только UUID, где
// только почту, где только имя, — и строки нельзя было сопоставить между
// разделами. Это админка: должно быть видно всё три.

const nameStyle = { fontWeight: 600, color: '#1a1f36', lineHeight: 1.3 };
const ownerStyle = { fontSize: 12, color: '#697386', marginTop: 2 };
const idStyle = { fontSize: 12, color: '#a3acb9', fontFamily: 'monospace', marginTop: 2 };
const noteStyle = { fontSize: 12, color: '#8a94a6', marginTop: 2 };

/**
 * Ячейка сущности.
 *
 * @param name   что это (название проекта, кабинета, тариф, номер счёта)
 * @param owner  чей он — e-mail; прочерк, если владельца нет
 * @param id     UUID сущности
 * @param note   необязательная подпись: тип, статус, ИНН и прочее
 * @param extra  произвольные узлы под подписью
 */
function EntityCell({ name, owner, id, note, extra }) {
  return (
    <div>
      <div style={nameStyle}>{name || '—'}</div>
      {owner !== undefined && <div style={ownerStyle}>{owner || '—'}</div>}
      {note && <div style={noteStyle}>{note}</div>}
      {id && <div style={idStyle}>{id}</div>}
      {extra}
    </div>
  );
}

export default EntityCell;
